<template>
  <div class="usc-course gutter-md mb">
    <div class="usc-course__blocks">
      <slot name="image"></slot>
    </div>
    <hr>
    <details>
      <summary>Click here to view the accessible version of the curriculum</summary>
      <h3>{{dataSet.title}}</h3>
      <h4>{{dataSet.subtitle}}</h4>

      <div class="usc-course__key">
        <usc-course-key v-for="(key, index) in dataSet.key" :key="key.id" :color="key.courseColor" :label="key.courseLabel">
        </usc-course-key>
      </div>
      <div class="usc-course__year" v-for="(year, index) in dataSet.years" :key="year.id">
        <h4 class="usc-course__year-title">{{year.yearTitle}}</h4>
        <div class="usc-course__semesters-container">
          <usc-course-semester class="usc-course__semester" v-for="(semester, index) in year.semesters" :key="semester.id" :semester="semester" :name="index"></usc-course-semester>
        </div>
      </div>
    </details>
    <hr>

    <!-- <div v-if="unitsHasRange" class="usc-course__total-units">
      Total Units = {{totalUnits.min}}-{{totalUnits.max}}
    </div>
    <div v-else class="usc-course__total-units">
      Total Units = {{totalUnits.max}}
    </div> -->
  </div>
</template>

<script>
import CourseKey from '@/components/CourseChart/CourseChartKey'
import CourseSemester from '@/components/CourseChart/CourseSemester'
export default {
  name: 'CourseChart',
  components: {
    'usc-course-key': CourseKey,
    'usc-course-semester': CourseSemester
  },
  props: ['dataSet'],
  data () {
    return {

    }
  },
  computed: {
    totalUnits () {
      var totalUnits = {
        min: 0,
        max: 0
      }
      let i = 0
      if (this.dataSet.years.freshman !== undefined) {
        let freshman = this.dataSet.years.freshman

        if (freshman.semesters.Fall !== undefined) {
          for (i = 0; i < freshman.semesters.Fall.length; i++) {
            let fall = freshman.semesters.Fall[i]
            if (fall.hasMin) {
              totalUnits.min += fall.min
            } else {
              totalUnits.min += fall.courseCredits
            }
            totalUnits.max += fall.courseCredits
          }
        }

        if (freshman.semesters.Spring !== undefined) {
          for (i = 0; i < freshman.semesters.Spring.length; i++) {
            let winter = freshman.semesters.Spring[i]
            if (winter.hasMin) {
              totalUnits.min += winter.min
            } else {
              totalUnits.min += winter.courseCredits
            }
            totalUnits.max += winter.courseCredits
          }
        }
      }

      if (this.dataSet.years.sophmore !== undefined) {
        let sophmore = this.dataSet.years.sophmore

        if (sophmore.semesters.Fall !== undefined) {
          for (i = 0; i < sophmore.semesters.Fall.length; i++) {
            let fall = sophmore.semesters.Fall[i]
            if (fall.hasMin) {
              totalUnits.min += fall.min
            } else {
              totalUnits.min += fall.courseCredits
            }
            totalUnits.max += fall.courseCredits
          }
        }

        if (sophmore.semesters.Spring !== undefined) {
          for (i = 0; i < sophmore.semesters.Spring.length; i++) {
            let winter = sophmore.semesters.Spring[i]
            if (winter.hasMin) {
              totalUnits.min += winter.min
            } else {
              totalUnits.min += winter.courseCredits
            }
            totalUnits.max += winter.courseCredits
          }
        }
      }

      if (this.dataSet.years.junior !== undefined) {
        let junior = this.dataSet.years.junior

        if (junior.semesters.Fall !== undefined) {
          for (i = 0; i < junior.semesters.Fall.length; i++) {
            let fall = junior.semesters.Fall[i]
            if (fall.hasMin) {
              totalUnits.min += fall.min
            } else {
              totalUnits.min += fall.courseCredits
            }
            totalUnits.max += fall.courseCredits
          }
        }

        if (junior.semesters.Spring !== undefined) {
          for (i = 0; i < junior.semesters.Spring.length; i++) {
            let winter = junior.semesters.Spring[i]
            if (winter.hasMin) {
              totalUnits.min += winter.min
            } else {
              totalUnits.min += winter.courseCredits
            }
            totalUnits.max += winter.courseCredits
          }
        }
      }

      if (this.dataSet.years.senior !== undefined) {
        let senior = this.dataSet.years.senior

        if (senior.semesters.Fall !== undefined) {
          for (i = 0; i < senior.semesters.Fall.length; i++) {
            let fall = senior.semesters.Fall[i]
            if (fall.hasMin) {
              totalUnits.min += fall.min
            } else {
              totalUnits.min += fall.courseCredits
            }
            totalUnits.max += fall.courseCredits
          }
        }

        if (senior.semesters.Spring !== undefined) {
          for (i = 0; i < senior.semesters.Spring.length; i++) {
            let winter = senior.semesters.Spring[i]
            if (winter.hasMin) {
              totalUnits.min += winter.min
            } else {
              totalUnits.min += winter.courseCredits
            }
            totalUnits.max += winter.courseCredits
          }
        }
      }
      return totalUnits
    },
    unitsHasRange () {
      if (this.totalUnits.min === this.totalUnits.max) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "~styles/_vars";
  @import '~styles/mixins';

  h3 {
    margin-bottom: 10px;
  }
  hr {
    border-width: 1px 0 0;
    border-top: 1px solid $cBorder;
  }
  .usc-course {
    // margin-bottom: 60px;
    &__key {
      display: flex;
      flex-flow: row wrap;
      padding-top: 30px;
      padding-bottom: 10px;
    }
    &__year {
      padding-top: 30px;
      border-bottom: 1px solid $cBorder;
    }
    &__year-title {
      margin-bottom: 16px;
    }
    &__semesters-container {
      display: flex;
      flex-flow: row wrap;
      margin: 0 -6px;
    }
    &__semester {
      width: 100%;
      padding: 0 6px;
      display: flex;
      flex-flow: column nowrap;
      @media (min-width: 800px) {
        width: 45%;
        padding: 0 6px;
        display: flex;
        flex-flow: column nowrap;
      }
    }
    &__total-units {
      display: flex;
      justify-content: flex-end;
      font-size: 17px;
      font-family: $fNational;
      font-weight: $fBold;
      text-transform: uppercase;
      line-height: 1.412;
      margin-top: 30px;
    }
  }
  .usc-course__blocks {
    > img {
      @include img-fluid;
    }
  }
  .Divider {
    background-color: rgb(0, 0, 0);
    opacity: 0.071;
    position: absolute;
    left: 3472px;
    top: 2244px;
    width: 748px;
    height: 1px;
    z-index: 799;
  }
</style>



// WEBPACK FOOTER //
// src/components/CourseChart/CourseChart.vue